import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

/**
 * Sparkle Icon used for AI Summaries.
 * Supports outlined (default) and filled (selected) states.
 */
export const SparkleSummariesIcon: FunctionComponent<SparkleSummariesIconProps> = ({
  size = 24,
  fillColor,
  isFilled = false,
}) => {
  const { colors } = useTheme()
  const color = fillColor || colors.iconDefault

  if (isFilled) {
    return (
      <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={tID('SparkleSummariesIcon')}>
        <Path
          d='M12.0003 21.975C11.4833 21.975 11.0545 21.5463 11.0545 21.0292C11.0545 16.6408 7.34704 12.9459 2.97118 12.9459C2.45415 12.9459 2.02539 12.5171 2.02539 12.0001C2.02539 11.4831 2.45415 11.0543 2.97118 11.0543C7.35965 11.0543 11.0545 7.3468 11.0545 2.97094C11.0545 2.45391 11.4833 2.02515 12.0003 2.02515C12.5174 2.02515 12.9461 2.45391 12.9461 2.97094C12.9461 7.35941 16.6536 11.0543 21.0295 11.0543C21.5465 11.0543 21.9753 11.4831 21.9753 12.0001C21.9753 12.5171 21.5465 12.9459 21.0295 12.9459C16.641 12.9459 12.9461 16.6534 12.9461 21.0292C12.9461 21.5463 12.5174 21.975 12.0003 21.975Z'
          fill={color}
        />
      </Svg>
    )
  }

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' testID={tID('SparkleSummariesIcon')}>
      <Path
        d='M12 6.12671C11.0246 8.83866 8.84229 11.0235 6.12695 11.9998C8.8388 12.9751 11.0236 15.1577 12 17.8728C12.9754 15.1612 15.158 12.976 17.873 11.9998C15.1613 11.0242 12.9761 8.84194 12 6.12671ZM12.957 3.38062C13.1788 7.58687 16.7904 11.0543 21.0293 11.0544C21.5462 11.0544 21.9754 11.4829 21.9756 11.9998L21.9707 12.0955C21.9219 12.5688 21.5142 12.946 21.0293 12.946L20.6201 12.9568C16.4137 13.1784 12.9464 16.79 12.9463 21.0291L12.9414 21.1248C12.8926 21.598 12.4848 21.9753 12 21.9753L11.9043 21.9705C11.4627 21.9246 11.1052 21.5664 11.0596 21.1248L11.0547 21.0291C11.0546 16.7777 7.57482 13.1774 3.37891 12.9568L2.9707 12.946C2.45388 12.9458 2.02539 12.5166 2.02539 11.9998C2.02558 11.483 2.454 11.0547 2.9707 11.0544C7.22219 11.0544 10.8233 7.57464 11.0439 3.37866L11.0547 2.97046C11.055 2.45375 11.4833 2.02533 12 2.02515C12.5169 2.02515 12.946 2.45364 12.9463 2.97046L12.957 3.38062Z'
        fill={color}
      />
    </Svg>
  )
}

export type SparkleSummariesIconProps = {
  size?: string | number
  fillColor?: string
  isFilled?: boolean
}
